// extracted by mini-css-extract-plugin
export default {"wrapper":"nA-z","viewport":"oA-z","container":"pA-z","slide":"qA-z"};